import React, { useContext, useState, useEffect, useRef } from 'react'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
    paymentTypeRosoom,
} from '@/custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button, Menu, MenuItem } from '@mui/material'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import AuthContext from '@/product/context/auth/authContext'
import Loaders from '@/product/components/molecules/Loaders'
import Layout from '@/product/components/templates/Layout'
import ProductContext from '@/product/context/product/productContext'
import { useHistory } from 'react-router-dom'
import DynamicListing from '@/views/Listing/dynamicListing'
import ProductView from '@/custom/components/organisms/ProductView'
import ProductCommonContext from '@/product/context/common/commonContext'
import BidHistory from '@/custom/components/organisms/BidHistory'
import InvoiceComponent from '@/custom/components/organisms/InvoiceComponent'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import { useTranslation } from 'react-i18next'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const EditListing = (props) => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const productCommonContext = useContext(ProductCommonContext)
    const [changeStatus, setChangeStatus] = useState(false)
    const { t } = useTranslation()

    const { user } = authContext
    const {
        projectAction,
        single_project,
        getSingleProject,
        changeProductStatus,
        responseStatus: responseStatusProduct,
    } = productContext
    const { setBidHistoryValue } = productCommonContext
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            date_closed: dateTimeFormatFunction(new Date()),
            mainUpdate: false,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            if (
                values.action === 'open' ||
                values.action === 'removed' ||
                values.action === 'unsold' ||
                values.action === 'date_closed'
            ) {
                const value = values
                // if (value.action === 'date_closed') {
                //     value.date_closed = moment(
                //         value.date_closed,
                //         'MM-DD-YYYY h:mm a'
                //     ).format()
                // }
                changeProductStatus(value)
            }
        },
    })

    useEffect(() => {
        setIsLoading(true)
        if (props.match.params.id) {
            getSingleProject({ id: props.match.params.id })
            setManage({
                popup: true,
                status: 'edit',
                id: props.match.params.id,
                projectType: 12,
            })
        }
    }, [props.match.params.id])

    const onSelectMultiProducts = (data, action) => {
        console.log(data, action, 'coming action')
        formikSelection.values.action = action
        formikSelection.values.project_id = data
        formikSelection.values.mainUpdate = false
        formikSelection.values.date_closed = dateTimeFormatFunction(new Date())
        formikSelection.values.auction_id = ''
        if (action === 'auction_assign') {
            if (activeAuctions.length) {
                formikSelection.values.auction_id = activeAuctions[0].value
            }
            setAssignAuction(true)
        } else if (
            action === 'open' ||
            action === 'removed' ||
            action === 'unsold'
        ) {
            if (action === 'removed') {
                if (single_project.record.bidscount > 0) {
                    setAlert('Listings with bids cannot be deleted', 'error')
                } else {
                    setChangeStatus(true)
                }
            } else {
                setChangeStatus(true)
            }
        } else if (action === 'date_closed') {
            formikSelection.values.mainUpdate = true
            setChangeStatus(true)
        }
    }

    useEffect(() => {
        if (
            single_project?.record &&
            Object.keys(single_project.record).length
        ) {
            setIsLoading(false)
        }
    }, [single_project])

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.status === 'success') {
                if (responseStatusProduct.from === 'productchange') {
                    setChangeStatus(false)
                    getSingleProject({ id: props.match.params.id })
                }
            }
        }
    }, [responseStatusProduct])

    const closeFunction = () => {
        history.goBack()
        window.scrollTo(0, 0)
    }

    const dateClosed = {
        formik: formikSelection,
        data: [
            {
                label: 'Change End Date *',
                placeholder: 'Ender End Date',
                disablePast: true,
                type: 'datetime',
                class: `col-12 ${
                    formikSelection.values.mainUpdate ? '' : 'd-none'
                }`,
                name: 'date_closed',
                minDate: dateTimeFormatFunction(new Date()),
                minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                    new Date()
                )}`,
                formik: formikSelection,
            },
        ],
    }

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="fspBody">
                {' '}
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <>
                        <div className="buyerDetailsTab invoicesTab">
                            <div className="bdTop edit-listing-top">
                                <div className="bdUser text-left">
                                    <h2>
                                        {/* <span className="material-icons">
                                            account_circle
                                        </span> */}
                                        {single_project?.record?.title}
                                    </h2>
                                </div>
                                <div>
                                    {single_project.record.is_relist == 0 &&
                                    single_project.record.market_status !==
                                        'removed' ? (
                                        <>
                                            {' '}
                                            <Button
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={handleMenuClick}
                                                variant="outlined"
                                            >
                                                <span className="material-icons edit">
                                                    edit
                                                </span>
                                                Edit
                                                <span className="material-icons down">
                                                    expand_more
                                                </span>
                                            </Button>
                                            <Menu
                                                id="simple-menu"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={handleMenuClose}
                                            >
                                                <>
                                                    {single_project.record
                                                        .market_status !==
                                                        'closed' &&
                                                    single_project.record
                                                        .market_status !==
                                                        'draft' ? (
                                                        <MenuItem
                                                            onClick={() => {
                                                                setAnchorEl(
                                                                    null
                                                                )
                                                                onSelectMultiProducts(
                                                                    [
                                                                        single_project
                                                                            .record
                                                                            .id,
                                                                    ],
                                                                    'unsold'
                                                                )
                                                            }}
                                                        >
                                                            Move to Unsold
                                                        </MenuItem>
                                                    ) : null}

                                                    {single_project.record
                                                        .market_status !==
                                                    'sold' ? (
                                                        <MenuItem
                                                            onClick={() => {
                                                                setAnchorEl(
                                                                    null
                                                                )
                                                                onSelectMultiProducts(
                                                                    [
                                                                        single_project
                                                                            .record
                                                                            .id,
                                                                    ],
                                                                    'removed'
                                                                )
                                                            }}
                                                        >
                                                            Delete
                                                        </MenuItem>
                                                    ) : null}

                                                    {single_project.record
                                                        .market_status !==
                                                        'sold' &&
                                                    single_project.record
                                                        .market_status !==
                                                        'closed' &&
                                                    single_project.record
                                                        .market_status !==
                                                        'draft' ? (
                                                        <MenuItem
                                                            onClick={() => {
                                                                setAnchorEl(
                                                                    null
                                                                )
                                                                onSelectMultiProducts(
                                                                    [
                                                                        single_project
                                                                            .record
                                                                            .id,
                                                                    ],
                                                                    'date_closed'
                                                                )
                                                            }}
                                                        >
                                                            Change End Date
                                                        </MenuItem>
                                                    ) : null}

                                                    {/* {single_project.record
                                                        .market_status !==
                                                        'open' &&
                                                    single_project.record
                                                        .market_status !==
                                                        'sold' &&
                                                    single_project.record
                                                        .market_status !==
                                                        'closed' ? (
                                                        <MenuItem
                                                            onClick={() => {
                                                                setAnchorEl(
                                                                    null
                                                                )
                                                                onSelectMultiProducts(
                                                                    [
                                                                        single_project
                                                                            .record
                                                                            .id,
                                                                    ],
                                                                    'open'
                                                                )
                                                            }}
                                                        >
                                                            Move to Active
                                                        </MenuItem>
                                                    ) : null} */}
                                                </>
                                            </Menu>{' '}
                                        </>
                                    ) : null}
                                </div>
                            </div>

                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label={t('Offering Info')}
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />
                                    <Tab
                                        label="Bids"
                                        value={1}
                                        onClick={() => handleChange(1)}
                                    />
                                    {single_project?.record?.market_status ===
                                    'sold' ? (
                                        <Tab
                                            label="Invoices"
                                            value={2}
                                            onClick={() => handleChange(2)}
                                        />
                                    ) : null}
                                    <Tab
                                        label={t('Edit Offering')}
                                        value={3}
                                        onClick={() => handleChange(3)}
                                    />
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <ProductView
                                    productId={props.match.params.id}
                                    productData={single_project.record}
                                />
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <BidHistory
                                    projectId={props.match.params.id}
                                    noModal={true}
                                    show_company={true}
                                    second={true}
                                    get_proxy={true}
                                    no_userid={true}
                                />
                            </TabPanel>

                            {single_project?.record?.market_status ===
                            'sold' ? (
                                <TabPanel value={value} index={2}>
                                    <div className="auctionInvoices">
                                        <InvoiceComponent
                                            props={{
                                                ...props,
                                                winnerInvoiceId:
                                                    single_project.record
                                                        ?.buynow_common_invoice,
                                                winnerUserId:
                                                    single_project.record
                                                        ?.buynow_user_id,
                                                removeActions: true,
                                            }}
                                        />
                                    </div>
                                </TabPanel>
                            ) : null}

                            <TabPanel value={value} index={3}>
                                <div className="editAuctionTab">
                                    <DynamicListing
                                        data={manage}
                                        standalone={true}
                                        closeFunction={closeFunction}
                                        function={closeFunction}
                                        seller={props.seller}
                                    />
                                </div>
                            </TabPanel>

                            <CustomDialog
                                title={'Change product status'}
                                open={changeStatus}
                                function={changeChangeStatus}
                            >
                                <h5>
                                    Are you sure you want to change the status
                                </h5>
                                <div className="row">{mapData(dateClosed)}</div>
                                <div className="actionWrapper">
                                    <Button
                                        onClick={() => changeChangeStatus()}
                                    >
                                        Cancel
                                    </Button>
                                    <form
                                        onSubmit={formikSelection.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <PrimaryButton
                                            type="submit"
                                            label="Confirm"
                                        />
                                    </form>
                                </div>
                            </CustomDialog>
                        </div>
                    </>
                )}
            </div>
        </Layout>
        // </FullScreenPopup>
    )
}

export default EditListing
